export default __webpack_public_path__ + "static/media/banner-home-mobile.png.743d05cc.old";